/**
 * Schemas to validate questionnaire configurations
 */
import { z } from 'zod';

/**
 * A schema for a single question
 */
export const questionConfigSchema = z.object({
  id: z.number(),
  /**
   * The section where the question belongs in
   *
   * @deprecated Use the parent `QuestionnaireSubsectionConfig.title`
   */
  section: z.string(),
  /**
   * The question text
   */
  title: z.string(),
  categories: z.array(z.string())
});

export interface QuestionConfig extends z.infer<typeof questionConfigSchema> {}

/**
 * A section that contains 0 or more questions
 */
export const questionnaireSubsectionConfigSchema = z.object({
  id: z.string(),
  description: z.string(),
  instructions: z.string(),
  min: z.number(),
  max: z.number(),
  title: z.string().optional(),
  type: z.enum(['button', 'slider']).default('button'),
  beforeLabel: z.string(),
  afterLabel: z.string(),
  /**
   * Control if the rating colors should go in ascending order (red to green).
   * Cases:
   * 1. `true`: The component renders the colors in ascending order.
   * 2. `false`: The component renders the colors indescending order.
   */
  colorsForward: z.boolean(), //.optional().default(true),
  /**

   */
  /**
   * Control if the icons (`beforeIcon`, `afterIcon`) should be displayed in ascending order.
   * Cases:
   * 1. `true`: The component renders `beforeIcon` then `afterIcon`.
   * 2. `false`: The component renders `afterIcon` then `beforeIcon`.
   *
   * Cases
   * - `false`: The scale is: [good, bad]
   * - `true`: The scale is: [bad, good]
   *
   * WARNING: This does not impact the order of `beforeLabel` and `afterLabel`.
   *
   * TODO: Change this configuration to use a string enum for clarity.
   */
  iconsForward: z.boolean(), //.optional().default(true),
  questions: z.array(questionConfigSchema)
});

export interface QuestionnaireSubsectionConfig
  extends z.infer<typeof questionnaireSubsectionConfigSchema> {}

/**
 * A questionnaire that contains 0 or more sections
 */
export const questionnaireConfigSchema = z.object({
  id: z.string(),
  subsections: z.record(z.string(), questionnaireSubsectionConfigSchema)
});

export interface QuestionnaireConfig
  extends z.infer<typeof questionnaireConfigSchema> {}
